<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'newgoodsapprovalForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeInit(next){
				next()
			},
			search(goodsurl) {
				let goodscode = ''
				if (!goodsurl) {
					this.$message.error('请输入商品链接或商品ID')
					return
				}
				if (goodsurl.startsWith('http')) {
					let queryParams = new URLSearchParams(new URL(goodsurl).search)
					if (!queryParams.get('id')) {
						this.$message.error('商品ID获取失败')
						return
					}
					goodscode = queryParams.get('id')
				} else {
					goodscode = goodsurl
				}				
				this.loading = true
				return new Promise((reslove,reject)=>{
					this.$api.BICompetitivegoods.search({
						goodscode:goodscode,
						date: [this.$Moment().subtract(30, 'days').valueOf(),this.$Moment().valueOf()],
						goodsurl: goodsurl
					}).then((res) => {
						this.loading = false
						reslove(res)
					}, () => {
						this.loading = false
						reject()
					})
				})
			},
			tableAdd(e) {
				if(e.moduleName == 'newgoodsapproval_goods'){
					let message = '产品链接'
					let title = '输入'
					let option = {
						distinguishCancelAndClose: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						closeOnClickModal: false
					}
					this.$prompt(message, title, option).then((data) => {
						this.search(data.value).then((res)=>{
							let base = res.find((item)=>{
								return item.id == '基础分析'
							})
							if(base){
								let obj = {}
								obj.gmv = base.gmv.toFixed(2)
								obj.paypercent = (base.paidClick && base.clickCost && base.gmv) ? (base.paidClick * base.clickCost/base.gmv * 100).toFixed(2) : null
								obj.price = base.averageOrderValue?base.averageOrderValue.toFixed(2):null
								obj.goodsurl = data.value
								e.obj = obj
								e.next()
							}else{
								this.$message.error('未查询到数据')
							}
						},()=>{
							
						})
					}).catch(() => {

					})
				}else{
					e.next()
				}

			},
		},
		components: {

		}
	}
</script>
